import $ from 'jquery';
import browser from '@openclassrooms/utils/browser';

import widgetFactory from '../../widgetFactory';
import MediaVideoService from '../../../Services/Media/video';

const widgetName = 'vimeoPlayer',
  vimeoApiUrl = '//player.vimeo.com/api/player.js';

let vimeoApiPromise;

// widget definition
const widget = widgetFactory(widgetName, {
  options: {
    onPlay: $.noop(),
    onPause: $.noop(),
    onFinish: $.noop(),
  },

  _create: function () {
    this._super(widgetName);

    this.player = null;

    this.elements.$iframe = this.element;

    if (this.elements.$iframe.is('video')) {
      this.elements.$iframe = MediaVideoService.videoToIframe(this.elements.$iframe);
      this.element = this.elements.$iframe;
    }

    if (!vimeoApiPromise) {
      vimeoApiPromise = $.getScript(vimeoApiUrl);
    }

    const checkVimeoReady = () => {
      if (!browser.window.Vimeo) {
        browser.window.requestAnimationFrame(checkVimeoReady);
        return;
      }

      this.player = new browser.window.Vimeo.Player(this.elements.$iframe.get(0));
      this._addEvents();
    };

    vimeoApiPromise.done(checkVimeoReady);
  },

  _addEvents: function () {
    const player = this.player;

    player.on('play', () => {
      this._trigger('onPlay');
    });

    player.on('pause', () => {
      this._trigger('onPause');
    });

    player.on('ended', () => {
      this._trigger('onFinish');
    });

    player.on('timeupdate', (data) => {
      this._trigger('onProgress', null, data);
    });
  },

  pause: function () {
    this.player.pause();
  },

  play: function () {
    this.player.play();
  },

  getType: function () {
    return 'vimeo';
  },

  getSourceUrl: function () {
    return this.element.data('src-origine');
  },

  getVideoDuration: function () {
    return this.player.getDuration();
  },
  getPlaybackRate: function () {
    return this.player.getPlaybackRate();
  },
});

export default widget;
